import Vue from '../../lib/vue2.js';

Vue.component('vueRecaptcha2', {
    name: 'vueRecaptcha2',
    template: '#recaptcha2',
    components: {
    },
    props: {
    },
    watch: {
    },
    data: function () {
        return {
            token: ''
        };
    },
    mounted: function() {

        window.grecaptchaReady.then(() => {
            grecaptcha.render(this.$refs.captcha, {
                'sitekey' : window.googleRecapctha2Key,
                'callback' : this.submitToken,
                'expired-callback' : this.expiredToken
            });
        });

    },
    created: function () {
        console.log('created recaptcha2 component');
    },
    methods: {
        submitToken: function(token) {
            console.log("recaptcha2 submitToken");
            this.token = token;
            this.$emit('input', token);
        },
        expiredToken: function() {
            console.log("recaptcha2 expiredToken");
            grecaptcha.reset();
        }
    }
});